    document.querySelector(".product-form--atc").addEventListener("DOMSubtreeModified", () => {
        // Select the parent element with class "product-form--atc"
        let visitorsCounterParent = document.querySelector(".product-form--atc");
    
        // Select the child element with ID "effectiveAppsProductVisitorsCounterElement"
    
        let visitorsCounterElement = visitorsCounterParent.querySelector("#effectiveAppsProductVisitorsCounterElement");

        // Select the parent element with class "product-block--description"
        let productBlockDesc = document.querySelector(".product-block--description");
    
        // Move the visitors counter element inside the product block description
        if (visitorsCounterElement) {
            productBlockDesc.appendChild(visitorsCounterElement);
        }
    });